'use client';

import { useDialogStore } from '@/app/lib/stores/dialog.store';
import MobileMenuButton from '@/app/ui/components/molecules/mobile-menu-button';
import { Button } from '@/app/ui/components/atoms/button';
import SearchDialogContent from '@/app/ui/layouts/docs/components/search-dialog';
import { useCallback } from 'react';
import SearchIcon from '../../../assets/icons/search-icon';
import LogoText from '../../../assets/logo-text';
import Link from 'next/link';

export default function HeaderMobile() {
  const { setIsDialogVisible, setDialogContent } = useDialogStore();

  const handleShowSearch = useCallback(() => {
    setIsDialogVisible(true);
    setDialogContent(<SearchDialogContent />);
  }, [setDialogContent, setIsDialogVisible]);

  return (
    <header className='flex size-full items-center justify-between border-b border-gray-200 px-3 py-4 md:px-6 xl:hidden'>
      <div className='flex items-center justify-start gap-4'>
        <MobileMenuButton />
        <Link href='/' aria-label='Home' title='Home'>
          <LogoText />
        </Link>
      </div>
      <Button variant='text' size='xsmall' iconOnly className='mr-3' aria-label='Search'>
        <SearchIcon onClick={handleShowSearch} />
      </Button>
    </header>
  );
}
